import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import endpoints from './endpoints'
import Vuex from 'vuex'
import logger from './helpers/logger.helper'
import popup from './helpers/popup.helper'
import VueSweetAlert from 'vue-sweetalert'
import VueJquery from 'vue-jquery'
import VueResource from 'vue-resource'
import http from './helpers/http.helper'
import aclMixin from './helpers/mixins/_aclMixin'
import initServiceMixin from './helpers/mixins/_initServiceMixin'
import VueAuthImage from './directives/vue-auth-image'
import VueAuthFileDownload from './directives/vue-auth-file-download'
import SocketService from './services/socket.service'
// import Notify from 'vue2-notify'
// import Snotify from 'vue-snotify'
import VueOnToast from 'vue-on-toast'
import pace from 'pace-progress'
import VueLazyLoad from 'vue-lazyload'
import * as Vue2Leaflet from 'vue2-leaflet' // VALID

import L from 'leaflet'
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

pace.options = {
  ajax: true,
  restartOnRequestAfter: true,
  restartOnPushState: true
}

Vue.config.productionTip = false
Vue.config.endpoints = endpoints

console.log(endpoints)

Vue.prototype.$logger = logger
Vue.prototype.$popup = popup

require('./helpers/includes/locale.include')
require('./helpers/includes/ui.include')
require('./helpers/includes/logic.include')

Vue.use(VueLazyLoad)
Vue.use(VueSweetAlert)
Vue.use(VueJquery)
Vue.use(VueResource)
Vue.use(VueAuthImage)
Vue.use(VueAuthFileDownload)
// Vue.use(Notify, { position: 'top-right', duration: 3000 })
// Vue.use(Snotify)
Vue.use(VueOnToast)
Vue.use(pace)

Vue.http.options.credentials = true
http.init(Vue.http)
Vue.prototype.$api = http

store.dispatch('checkAuth').then(() => {
  /* eslint-disable no-new */
  Vue.mixin(aclMixin)
  Vue.mixin(initServiceMixin)

  Vue.prototype.$socket = new SocketService()

  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    computed: {
      ...Vuex.mapGetters(['isLoggedIn', 'userName', 'boxed', 'isSidebarFull', 'userId'])
    },
    beforeCreate () {
    },
    beforeMount () {
      this.$adjustAjax()
    },
    created () {
      if (this.$route.meta.title) {
        document.title = this.$route.meta.title + ' | SAAD'
      } else {
        document.title = 'SAAD'
      }
      this.reapplySidebarStyle()
      this.$stylify()
    },
    mounted () {
      pace.restart()
      this.$adjustAjax()
      this.$adjustHandlers()
    },
    methods: {
      $adjustAjax () {
        $.ajaxSetup({
          headers: {
            'Authorization': 'Bearer ' + this.$store.getters.isLoggedIn
          },
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.getters.isLoggedIn)
            console.log(xhr)
          },
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true
        })
      },
      reapplySidebarStyle () {
        if (this.isSidebarFull) {
          document.body.classList.remove('sidebar-xs')
        } else {
          document.body.classList.add('sidebar-xs')
        }
      }
    },
    watch: {
      '$route': function (from, to) {
        this.reapplySidebarStyle()
        this.$stylify()
        if (this.$route.meta.title) {
          document.title = this.$route.meta.title + ' | SAAD'
        } else {
          document.title = 'SAAD'
        }
        if (!!to.meta && !!to.meta.breadcrumb) {
          // this.breadcrumbList = to.meta.breadcrumb
        }
      }
    }
  })
})

// eslint-disable-next-line
import './assets/js/core/libraries/jquery.min'
// eslint-disable-next-line
import './assets/js/core/libraries/bootstrap.min'
// eslint-disable-next-line
import './assets/js/plugins/forms/styling/uniform.min'
// eslint-disable-next-line
import './assets/js/core/app'
